export const iconFontAwesomeMapsMartiniGlassEmpty = (
	<i className="fa-solid fa-martini-glass-empty"></i>
);
